/**
 * Chip del consentimiento de un contacto de la base: «Sí» (emerald), «Sin dato» (slate), «Dijo que no» (red).
 * Cualquier valor que no sea un sí explícito se pinta como «Sin dato» o «Dijo que no», nunca como «Sí»
 * (fail-closed, D3): la regla vive en `textoConsentimiento`.
 */

import type { ConsentimientoContacto } from "../../types.base";
import { textoConsentimiento } from "../../logic/base";

export function ChipConsentimiento({ valor, grande = false }: { valor: boolean | null | undefined | ConsentimientoContacto; grande?: boolean }) {
  const t = textoConsentimiento(valor);
  return (
    <span className={`${grande ? "text-xs px-2.5 py-1" : "text-[10px] px-2 py-0.5"} font-bold uppercase tracking-wider rounded-full whitespace-nowrap ${t.cls}`}>
      {t.label}
    </span>
  );
}

export default ChipConsentimiento;
